import styled from "@emotion/styled";
import { Input as F7Input } from "framework7-react";
import { useCallback } from "react";

import { formatShortDateWithYear } from "@/config/date-fns";
import { useCalendarStore } from "@/stores/calendarStore";

const Input = styled(F7Input)`
  ::after {
    content: "" !important;
    display: none !important;
  }
  input {
    text-align: center;
  }
`;

function formatValue(values: Date[]) {
  if (!values || values.length === 0) return "";
  return formatShortDateWithYear(values[0]);
}

export function DailyReviewPageTitle() {
  const {
    daily: { select, date },
  } = useCalendarStore();

  const onCalendarChange = useCallback<(calendarValues: Array<Date> | undefined) => void>(
    (calendarValues) => {
      const newDate = calendarValues?.[0];
      if (newDate) {
        select(newDate);
      }
    },
    [select],
  );

  return (
    <Input
      readonly
      calendarParams={{
        formatValue,
        maxDate: new Date(),
      }}
      placeholder="Your birth date"
      style={{ border: "none" }}
      type="datepicker"
      value={[date]}
      onCalendarChange={onCalendarChange}
    />
  );
}
